import { Tab, Tabs } from '@material-ui/core'
import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

import BaseEntity from 'app/components/BaseEntity'
import { PageTabsBar } from 'app/components/generic/PageLayout'
import { navigationPaths } from 'app/config'
import constants from 'app/constants'
import { confirm, eventEmitter } from 'app/helpers'
import {
  fetchPlaydateSubjectData,
  fetchSubjectData,
  fetchToddlerClubSubjectData,
  updateClassData
} from 'app/store/actions/classEntity'

import { columns as extracurricularColumns } from './columns/extracurricular'
import { columns as regularColumns } from './columns/regular'

const TAB_BY_PATH = {
  [navigationPaths.subject]: 'regular',
  [navigationPaths.playdateSubject]: 'playdate',
  [navigationPaths.toddlerClubSubject]: 'toddlerClub'
}

const PATH_BY_TAB = {
  regular: navigationPaths.subject,
  playdate: navigationPaths.playdateSubject,
  toddlerClub: navigationPaths.toddlerClubSubject
}

const Subjects = () => {
  const history = useHistory()
  const { pathname } = useLocation()
  const currentTab = TAB_BY_PATH[pathname] || 'regular'

  const regularData = useSelector(
    (state) => state.classEntityReducer.subjectData
  )
  const playdateData = useSelector(
    (state) => state.classEntityReducer.playdateSubjectData
  )
  const toddlerClubData = useSelector(
    (state) => state.classEntityReducer.toddlerClubSubjectData
  )

  const regularSaveFunction = (formData, onSave) => {
    if (formData?.progress_enabled === 'true') {
      const onError = () => {
        eventEmitter.emit(constants.MODAL_FORM_SAVE_ERROR)
      }
      confirm(
        onSave,
        `Are you sure you want to enable journey for this category?`,
        onError
      )
    } else onSave()
  }

  const handleTabChange = (_, value) => {
    if (value !== currentTab) history.push(PATH_BY_TAB[value])
  }

  const renderTabContent = () => {
    switch (currentTab) {
      case 'regular':
        return (
          <BaseEntity
            entity={constants.SUBJECT}
            label={constants.SUBJECT_LABEL}
            columns={regularColumns}
            data={regularData}
            fetchData={fetchSubjectData}
            updateEntityData={updateClassData}
            beforeSaveFunction={regularSaveFunction}
          />
        )
      case 'playdate':
        return (
          <BaseEntity
            entity={constants.PLAY_DATE_SUBJECT}
            label={constants.PLAY_DATE_SUBJECT_LABEL}
            columns={extracurricularColumns}
            data={playdateData}
            fetchData={fetchPlaydateSubjectData}
            updateEntityData={updateClassData}
          />
        )
      case 'toddlerClub':
        return (
          <BaseEntity
            entity={constants.TODDLER_CLUB_SUBJECT}
            label={constants.TODDLER_CLUB_SUBJECT_LABEL}
            columns={extracurricularColumns}
            data={toddlerClubData}
            fetchData={fetchToddlerClubSubjectData}
            updateEntityData={updateClassData}
          />
        )
      default:
        return null
    }
  }

  return (
    <>
      <PageTabsBar>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Regular" value="regular" />
          <Tab label="Playdate" value="playdate" />
          <Tab label="Toddler Club" value="toddlerClub" />
        </Tabs>
      </PageTabsBar>
      {renderTabContent()}
    </>
  )
}

export default Subjects
